import React from 'react';
import { X } from 'app/BargainWidget/Bargains/WidgetV1/icons/Icons';
import { AnimatePresence, motion } from 'framer-motion';
import ReactDOM from 'react-dom';

type SharedModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
};

export function BargainModalV1({ children, isOpen, onClose, className }: SharedModalProps) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      {isOpen && (
        <div id={"bargain-modal-root"} className={`se-fixed se-inset-0 se-z-50 se-flex se-items-center se-justify-center se-p-4 ${className} bargain-modal-v1-wrapper`}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="se-fixed se-inset-0 se-bg-black/30 se-backdrop-blur-sm bargain-modal-v1"
            onClick={onClose}
          >
            &nbsp;
          </motion.div>
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
            className="se-relative bargain-modal-v1-header"
          >
            <button
              onClick={onClose}
              className="se-absolute -se-right-2 -se-top-2 se-z-10 se-rounded-full se-bg-white se-p-1.5 se-text-gray-500 se-shadow-lg hover:se-text-gray-800 se-transition-colors bargain-modal-v1-close-button"
            >
              <X className="se-h-4 se-w-4 bargain-modal-v1-close-button-icon" />
            </button>
            <div className="se-rounded-lg se-w-full se-overflow-y-auto se-overflow-x-hidden se-max-h-[92vh] bargain-modal-v1-body">
              {children}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body,
  );
}
